export default {
  homeworks: [],
};
